import script from "./table-columns-set.vue?vue&type=script&lang=tsx&setup=true"
export * from "./table-columns-set.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__